import Link from '@/components/Link'
import SocialIcon from '@/components/social-icons'
import siteMetadata from '@/data/siteMetadata'

export default function Footer() {
  return (
    <footer>
      <div className="mt-16 flex flex-col items-center pb-6">
        <div className="my-3 flex space-x-4">
          <SocialIcon kind="mail" href={`mailto:${siteMetadata.email}`} size={6} />
        </div>

        <div className="flex flex-col space-y-2 text-center text-sm text-gray-500 dark:text-gray-400 sm:flex-row sm:space-x-2 sm:space-y-0 sm:text-left">
          <div>
            <Link
              href="https://bitebooker.it"
              className="text-secondary hover:text-secondary-500 dark:text-primary dark:hover:text-primary-200"
            >
              {siteMetadata.author}
            </Link>
          </div>
          <div>{` • `}</div>
          <Link href="/">{siteMetadata.title}</Link>
          <div>{` • `}</div>
          <div>
            <Link
              href="https://www.freepik.com"
              className="text-secondary hover:text-secondary-500 dark:text-primary dark:hover:text-primary-200"
            >
              {`Images by Freepik`}
            </Link>
          </div>
        </div>
        <div className="my-3 flex space-x-4">
          <div suppressHydrationWarning>{`© ${new Date().getFullYear()}`}</div>
          <div>{` • `}</div>

          <span>
            {`${import.meta.env.PROD ? 'prod' : 'dev'}`} {__APP_VERSION__ + 'v'}
          </span>
        </div>
      </div>
    </footer>
  )
}
